/* eslint-disable jsx-a11y/anchor-is-valid */
//import axios from 'axios'
import React from 'react'
//import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {useIntl} from 'react-intl'
import {CardLoading} from '../loading/CardLoading'

//const API_URL = process.env.REACT_APP_API_URL || 'api'

type Props = {
  className: string
  issue_cost: string
  maintenance_cost: string
  renovation_cost: string
}

const CardSystemWidgetSGT2: React.FC<Props> = ({
  className,
  issue_cost,
  maintenance_cost,
  renovation_cost,
}) => {
  // const [total, setTotal] = useState('')
  const intl = useIntl()
  return (
    <div
      className={`card ${className} 
          border          
          border-gray-300                   
          `}
    >
      {/* begin::Body */}
      <div className='card-body p-5 p-xxl-6 d-flex align-items-start '>
        <div className=''>
          {issue_cost ? (
            <>
              {/* begin::Row */}
              <div className='row'>
                {/* begin::Col */}
                <div className='col-xl-12'>
                  <p className='mt-0 px-1 px-xxl-2 mb-4 fs-3 fw-bold'>
                    {intl.formatMessage({id: 'LICENSES.COST_RENEWAL'})}
                  </p>
                </div>

                <div className='col-xl-4 mt-2 mb-4 fs-7 fw-bold  '>
                  <div className='rounded border border-dashed border-gray-300 text-center'>
                    <div className='mt-2'>
                      Pagamentos de Participação
                      {/* {intl.formatMessage({id: 'LICENSES.ISSUE_COST'})} */}
                    </div>
                    <div className='mb-3 fs-5 text-success'>{'R$ ' + issue_cost}</div>
                  </div>
                </div>

                <div className='col-xl-4 mt-2 mb-4 fs-7 fw-bold  '>
                  <div className='rounded  border border-dashed border-gray-300 text-center'>
                    <div className='mt-2  px-1'>
                      Pagamentos de Dano Direto
                      {/* {intl.formatMessage({id: 'LICENSES.COST_MAINTENANCE'})} */}
                    </div>
                    <div className=' mb-3 fs-5 text-warning'>{'R$ ' + maintenance_cost}</div>
                  </div>
                </div>

                <div className='col-xl-4 mt-2 mb-4 fs-7 fw-bold'>
                  <div className='rounded border border-dashed border-gray-300 text-center'>
                    <div className='mt-2 px-1'>
                      Pagamento de Servidão
                      {/* {intl.formatMessage({id: 'LICENSES.COST_RENEWAL'})} */}
                    </div>
                    <div className='fs-5 mb-3 text-info'>{'R$ ' + renovation_cost}</div>
                  </div>
                </div>

                <div className='col-xl-4 mt-2 mb-4 fs-7 fw-bold '> </div>
              </div>
            </>
          ) : (
            <CardLoading />
          )}
        </div>
      </div>
      {/* end::Body */}
    </div>
  )
}

export {CardSystemWidgetSGT2}
